import { useQuery } from "@tanstack/react-query";

import {  getTranslatedTextApiCall } from "./utils.api";
import { translationKeys } from "../../../redux/services/translationKeys";

export const useGetTranslatedText = (languageId) =>{
    return useQuery({
        queryKey: translationKeys.getTranslatedTextKeys(languageId),
        queryFn: () => getTranslatedTextApiCall(languageId),
    });
}